<template>
  <template v-if="mobile">
    <RouterLink v-for="item in mobileItems" :key="item.name" ref="mobileLinks" class="admin-mobile-nav-link member-mobile-link" :class="{ 'admin-mobile-nav-link-wide': wideMobileItems.includes(item.name) || item.name === unpairedMobileItem }" :data-member-nav-item="item.name" :to="{ name: item.name }">{{ item.label }}</RouterLink>
  </template>
  <aside v-else class="dashboard-side">
    <RouterLink class="dashboard-brand" :to="{ name: 'member-dashboard' }">
      <img src="@/assets/img/icons/RassplFish.png" alt="" /><span>Member</span>
    </RouterLink>
    <nav class="dashboard-nav" aria-label="Member dashboard">
      <RouterLink v-for="item in items" :key="item.name" :to="{ name: item.name }">
        <component :is="item.icon" :size="19" aria-hidden="true" /><span>{{ item.label }}</span>
      </RouterLink>
    </nav>
  </aside>
</template>
<script>
import { LayoutDashboard, FileUp, Images, FileText, GalleryHorizontal, BarChart3, UsersRound, UserRound } from 'lucide-vue-next';
const items = [
  { name: 'member-dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { name: 'member-catch-uploads', label: 'Upload catches', icon: FileUp },
  { name: 'member-unsorted-uploads', label: 'Scorecard assist', icon: Images },
  { name: 'member-scorecard-history', label: 'Scorecard history', icon: FileText },
  { name: 'member-gallery', label: 'Gallery', icon: GalleryHorizontal },
  { name: 'member-leaderboard', label: 'Member leaderboard', icon: BarChart3 },
  { name: 'member-team-leaderboard', label: 'Team leaderboard', icon: UsersRound },
  { name: 'member-profile', label: 'Profile', icon: UserRound },
];
export default {
  name: 'MemberNavigation',
  props: { mobile: { type: Boolean, default: false } },
  data: () => ({ items, wideMobileItems: [] }),
  computed: {
    mobileItems() {
      const remaining = [...this.items], ordered = [];
      while (remaining.length) {
        const item = remaining.shift();
        ordered.push(item);
        if (this.wideMobileItems.includes(item.name)) continue;
        const partner = remaining.findIndex(candidate => !this.wideMobileItems.includes(candidate.name));
        if (partner >= 0) ordered.push(remaining.splice(partner, 1)[0]);
      }
      return ordered;
    },
    unpairedMobileItem() {
      const narrow = this.mobileItems.filter(item => !this.wideMobileItems.includes(item.name));
      return narrow.length % 2 ? narrow.at(-1).name : null;
    },
  },
  mounted() {
    if (!this.mobile) return;
    const menu = this.$refs.mobileLinks?.[0]?.$el?.parentElement;
    if (!menu) return;
    this.menuObserver = new ResizeObserver(() => this.updateMobileWidths());
    this.menuObserver.observe(menu);
    this.updateMobileWidths();
    document.fonts?.ready.then(() => { if (this.menuObserver) this.updateMobileWidths(); });
  },
  beforeUnmount() { this.menuObserver?.disconnect(); this.menuObserver = null; },
  methods: {
    updateMobileWidths() {
      const links = this.$refs.mobileLinks || [];
      const menu = links[0]?.$el?.parentElement;
      if (!menu || !menu.clientWidth) return;
      const number = value => parseFloat(value) || 0;
      const menuStyle = getComputedStyle(menu);
      const halfWidth = (menu.clientWidth - number(menuStyle.paddingLeft) - number(menuStyle.paddingRight) - number(menuStyle.columnGap)) / 2;
      const context = document.createElement('canvas').getContext('2d');
      if (!context) return;
      const wide = [];
      links.forEach(link => {
        const element = link.$el, style = getComputedStyle(element);
        context.font = style.font || `${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;
        const label = element.textContent.trim();
        const width = context.measureText(label).width + Math.max(0, label.length - 1) * number(style.letterSpacing);
        const spacing = number(style.paddingLeft) + number(style.paddingRight) + number(style.borderLeftWidth) + number(style.borderRightWidth);
        if (width + spacing + 2 > halfWidth) wide.push(element.dataset.memberNavItem);
      });
      wide.sort();
      if (wide.join() !== this.wideMobileItems.join()) this.wideMobileItems = wide;
    },
  },
};
</script>

<style scoped>
.member-mobile-link { white-space:nowrap; }
.dashboard-nav a span { white-space:nowrap; }
</style>
